import { CheckCircle2, XCircle } from "lucide-react";

export function ChecksList({ checks, testid }) {
  if (!checks || !checks.length) return null;
  return (
    <ul data-testid={testid} className="grid sm:grid-cols-2 gap-x-4 gap-y-1">
      {checks.map((c) => (
        <li key={c.id} data-testid={`${testid}-${c.id}`} data-ok={c.ok ? "1" : "0"} className="flex items-start gap-1.5 font-mono text-[10px]">
          {c.ok ? <CheckCircle2 size={12} className="text-[#22C55E] mt-px shrink-0" /> : <XCircle size={12} className="text-[#EF4444] mt-px shrink-0" />}
          <span className={c.ok ? "text-[#A3A3A3]" : "text-white"}>{c.label || c.id}{c.detail ? <span className="text-[#525252]"> · {String(c.detail)}</span> : null}</span>
        </li>
      ))}
    </ul>
  );
}
